/* BHALLO — barra fixa de "adicionar ao carrinho" no celular */
(function () {
  function init() {
    var bar = document.getElementById('BhalloStickyAtc');
    if (!bar) return;

    // move pro body: garante que o position:fixed nao quebre por causa de
    // algum ancestral com transform/filter
    if (bar.parentElement !== document.body) document.body.appendChild(bar);

    var realBtn = document.querySelector('.product-form__submit');
    var stickyBtn = document.getElementById('BhalloStickyBtn');
    if (!realBtn || !stickyBtn) {
      bar.remove();
      return;
    }

    function sync() {
      var out = realBtn.disabled;
      stickyBtn.disabled = out;
      stickyBtn.textContent = out ? 'Esgotado' : 'Adicionar ao carrinho';
    }
    sync();

    // mantem em sincronia quando o cliente troca de tamanho
    if (window.MutationObserver) {
      new MutationObserver(sync).observe(realBtn, {
        attributes: true,
        attributeFilter: ['disabled']
      });
    }

    stickyBtn.addEventListener('click', function () {
      realBtn.click();
    });

    // mostra a barra so quando o botao real esta fora da tela
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            var mostrar = !entries[i].isIntersecting;
            bar.classList.toggle('is-visible', mostrar);
            bar.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
            // avisa o CSS: no celular a abinha do cupom sai da frente enquanto
            // a barra de compra esta na tela (duas CTAs no mesmo canto e demais)
            document.body.classList.toggle('bhallo-atc-fixo-visivel', mostrar);
          }
        },
        { threshold: 0 }
      ).observe(realBtn);
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
